export default __webpack_public_path__ + "static/media/126.1f998b71.gif";